/**
 * Geode Voice (UPT-2000 lot V0) — référence non réactive de la session vocale
 * en cours (mémoire seule ; séparée du magasin pour éviter les imports
 * circulaires entre la session et le store).
 */
import type { VoiceSession } from './RealtimeVoiceSession';
import type { MockVoiceSession } from './MockVoiceSession';

export type AnyVoiceSession = VoiceSession | MockVoiceSession;

let current: AnyVoiceSession | null = null;

export const getVoiceSession = (): AnyVoiceSession | null => current;

export const setVoiceSession = (session: AnyVoiceSession | null): void => {
  current = session;
};

/** La session courante est un simulateur (zone de saisie à la place du micro). */
export const isMockVoiceSession = (session: AnyVoiceSession | null): session is MockVoiceSession =>
  session !== null && typeof (session as MockVoiceSession).submitPhrase === 'function';
